import React from "react";
import classNames from "classnames";

import { Chevron } from "src/app/components/Chevron/Chevron";
import SelectedFiltersCounter from "../../../AudiencesSearch/partials/SelectedFiltersCounter/SelectedFiltersCounter";

import "./Accordion.scss";

export default function Accordion({
  title,
  amount,
  open,
  onToggle,
  children,
  headerClassName,
}) {
  return (
    <div
      className={classNames(
        "accordion",
        !open && "accordion--collapsed",
        classNames,
      )}
    >
      <div
        onClick={onToggle}
        className={classNames(
          "accordion__header",
          open && "accordion__header--open",
          headerClassName,
        )}
      >
        <div className="accordion__header-title">
          <span className="accordion__header-title-text">{title}</span>
          <SelectedFiltersCounter amount={amount} />
        </div>
        <Chevron expanded={open} variant="white" />
      </div>

      {open && (
        <div className="accordion__content">
          <div className="accordion__content-inner">{children}</div>
        </div>
      )}
    </div>
  );
}
